export const DEFAULT_THEME = {
  primaryColor: '#e38528',
  storageKey: 'mainColor'
};

export const CURSOR_STATES = {
  DEFAULT: 'default',
  HOVER: 'hover',
  TEXT: 'text',
  IMAGE: 'image'
};

export const CURSOR_TARGETS = {
  hoverable: ['A', 'BUTTON'],
  hoverClasses: ['btn', 'skill-item', 'social-link'],
  textInputs: ['INPUT', 'TEXTAREA'],
  images: ['IMG']
};
